import React, { useEffect, useState } from 'react'

import Header from 'common/js/header/header';
import Loader from 'common/components/Loader';
import { toast, ToastContainer } from 'react-toastify';
import 'common/css/master.css';

import ClassTable from './classSectionTbl';
import { getClassData } from './hpcParentAssessmentSvc';
import ParentAssessmentSlider from './parentAssessmentSlider';



const HpcParentAssessmentQr = () => {

    const [loader, setLoader] = useState("none");
    const [opacity, setOpacity] = useState(1);
    const [sectionId, setSectionId] = useState(0);
    const [clsId, setClsId] = useState(0);
    const [clsSection, setClsSection] = useState("");
    const [lstClassSections, setLstClassSection] = useState([]);
    const [isPdfSliderVisible, setIsPdfSliderVisible] = useState(false);

    useEffect(() => {
        // console.log("HpcParentAssessmentQr called");
        getClassList();
    }, []);

    const getClassList = () => {
        // console.log("getClassList called");
        setLoader("block");
        setOpacity(0.5);
        getClassData(getClassListResponse);
    }

    const getClassListResponse = (data) => {
        // console.log("getClassListResponse called, data", data);
        if (data.status === "Success") {
            setLstClassSection(data.lstAllClassSections);
        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setLoader("none");
        setOpacity(1);
    }

    const openParentQr = async (pCls) => {
        // console.log("openParentQr called, pClsId", pClsId, ", pSectionId", pSectionId);
        await setClsId(pCls.classId);
        await setSectionId(pCls.classSectionId);
        await setClsSection(pCls.className + " - "+ pCls.section)
        openPdf();
    }

    const openPdf = (pSyllabusId, pSubjectId) => {
        // console.log("openPdf called");
        setIsPdfSliderVisible(true);
    }

    const closePdf = () => {
        // console.log("closePdf called");
        setIsPdfSliderVisible(false);
    }

    const handleServiceError = (svcMsg) => {
        if (svcMsg === "You are not Logged In") {
            toast.error("You are not logged in. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else if (svcMsg === "Server Timed Out, Login Again") {
            toast.error("Server timed out. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else {
            toast.error(svcMsg);
        }
    };

    return (
        <div >
            <Header />
            <ToastContainer autoClose={3000} hideProgressBar />
            <Loader loader={loader} position="fixed" />
            <div className="col-md-12 col-xs-12 col-centered padding-remove"
                style={{
                    cursor: (loader === "none") ? 'pointer' : 'none',
                    pointerEvents: (loader === "none") ? 'auto' : 'none',
                    opacity: opacity
                }}>
            </div >
            <div className="col-md-6 col-xs-11 col-centered padding-remove" style={{ marginTop: "10vh" }}>
                <ClassTable
                    lstClsSection={lstClassSections}
                    sectionId={sectionId}
                    setSectionId={setSectionId}
                    openParentQr={openParentQr}
                />
            </div >
            {
                isPdfSliderVisible ?
                    <div className='slider1-60'>
                        <ParentAssessmentSlider
                            clsId={clsId}
                            sectionId={sectionId}
                            clsSection={clsSection}
                            closeSlider={closePdf}
                        />
                    </div >
                    : null
            }
        </div >
    )

}

export default HpcParentAssessmentQr;
